import Vue from "vue";
import NftMixin from "@/components/NftMixin";
export default Vue.extend({
    name: "NftIcon",
    mixins: [NftMixin],
    data() {
        return {};
    },
});
